// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__jxvDt","image":"index_image__l5Ouh"};